export default "__VITE_ASSET__BMAwxxBK__"